import { render } from "./AdminVehicles.vue?vue&type=template&id=fbfddd90&scoped=true"
import script from "./AdminVehicles.vue?vue&type=script&lang=js"
export * from "./AdminVehicles.vue?vue&type=script&lang=js"

import "./AdminVehicles.vue?vue&type=style&index=0&id=fbfddd90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbfddd90"]])

export default __exports__